import { useState } from "react";

const navLinks = [
  { id: "overview", label: "影片概览" },
  { id: "content", label: "完整版内容" },
  { id: "versions", label: "版本差异" },
  { id: "quality", label: "高清画质" },
  { id: "faq", label: "常见问题" },
  { id: "guide", label: "观影提示" },
];

export default function SiteNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/90 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <a href="#top" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-film-line text-lg"></i>
            </span>
            <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">
              姐姐的朋友电影
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className="px-3 py-2 text-sm text-foreground-700 rounded-md hover:text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-2">
            <a
              href="#content"
              className="px-4 py-2 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              完整版包含哪些内容
            </a>
          </div>

          <button
            type="button"
            aria-label="展开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="px-2 py-3 text-sm text-foreground-800 border-b border-background-100 last:border-none hover:text-primary-700 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#content"
              onClick={() => setOpen(false)}
              className="mt-3 px-4 py-3 text-sm font-medium text-center rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              完整版包含哪些内容
            </a>
          </div>
        </div>
      )}
    </header>
  );
}